<template>
    <div id="contact">
        <section class="welcome">
            <div class="start">
                <h1><span>Контакты</span></h1>
                <feedback></feedback>
            </div>
            <div class="content">
                <div class="list">
<!--
                    <div class="item">
                        <div class="item-title">ГК&nbsp;&laquo;Ренна&raquo;</div>
                        <div class="item-content">
                            <span>Центральный офис</span>
                            <ul>
                                <li><a href="mailto:info@rennagroup.ru">info@rennagroup.ru</a></li>
                                <li><a href="tel:+74957058742">+7 (495) 705-87-42</a></li>
                            </ul>
                        </div>
                    </div>
-->

                    <div class="item">
                        <div class="item-title">Горячая линия</div>
                        <div class="item-content item-content-image1">
                            <!--<span>Служба качества</span>-->
                            <ul>
                                <li><a href="mailto:info@rennagroup.ru">info@rennagroup.ru</a></li>
                                <li><a href="tel:+88002006455">+8 (800) 200-64-55</a></li>
                            </ul>
                        </div>
                    </div>

<!--

                    <div class="item">
                        <div class="item-title">Производство</div>
                        <div class="item-block">
                            <div class="item-content item-content-image2">
                                <span>Кореновский молочно-консервный комбинат</span>
                                <ul>
                                    <li><a href="mailto:kmkk@kmkk.net">kmkk@kmkk.net</a></li>
                                    <li><a href="tel:+78614236236">+7 (86142) 362-36</a></li>
                                </ul>
                            </div>
                            <div class="item-content item-content-image3">
                                <span>Алексеевский молочноконсервный комбинат</span>
                                <ul>
                                    <li><a href="mailto:amkk@amkk.rennagroup.ru">amkk@amkk.rennagroup.ru</a></li>
                                    <li><a href="tel:+74723468440">+7 (47234) 68-440</a></li>
                                </ul>
                            </div>
                            <div class="item-content">
                                <span>Фабрика настоящего мороженого</span>
                                <ul>
                                    <li><a href="mailto:fnm-info@rennagroup.ru">fnm-info@rennagroup.ru</a></li>
                                    <li><a href="tel:+78614237024">+7 (86142) 370-24</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-title">ТД&nbsp;&laquo;Ренна&raquo;</div>
                        <div class="item-block">
                            <div class="item-content">
                                <span>Торговый дом</span>
                                <ul>
                                    <li><a href="mailto:tdrenna@tc.rennagroup.ru">tdrenna@tc.rennagroup.ru</a></li>
                                    <li><a href="tel:+79104037136">+7 (910) 403-71-36</a></li>
                                </ul>
                            </div>
                            <div class="item-content">
                                <span>Филиал в&nbsp;г.&nbsp;Санкт-Петербурге (Боровая&nbsp;47/2)</span>
                                <ul>
                                    <li><a href="mailto:yu.vahtenko@tc.rennagroup.ru">yu.vahtenko@tc.rennagroup.ru</a></li>
                                    <li><a href="tel:+78126405798">+7 (812) 640-57-98</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-title">Дистрибуция</div>
                        <div class="item-block">
                            <div class="item-content">
                                <span>Лидер-Москва</span>
                                <ul>
                                    <li><a href="mailto:operator.msk@dc.rennagroup.ru">operator.msk@dc.rennagroup.ru</a></li>
                                    <li><a href="tel:+74952551464">+7 (495) 255-14-64</a></li>
                                </ul>
                            </div>
                            <div class="item-content">
                                <span>Лидер-Краснодар</span>
                                <ul>
                                    <li><a href="mailto:ks.krasnodar@dc.rennagroup.ru">ks.krasnodar@dc.rennagroup.ru</a></li>
                                    <li><a href="tel:+78612002786">+7 (861) 200-27-86</a></li>
                                </ul>
                            </div>
                            <div class="item-content">
                                <span>Лидер-Кореновск</span>
                                <ul>
                                    <li><a href="mailto:LiderKorenovsk@dc.rennagroup.ru">LiderKorenovsk@dc.rennagroup.ru</a></li>
                                    <li><a href="tel:+79054328159">+7 (905) 432-81-59</a></li>
                                </ul>
                            </div>
                            <div class="item-content">
                                <span>Лидер-Воронеж</span>
                                <ul>
                                    <li><a href="mailto:operator.vrn@dc.rennagroup.ru">operator.vrn@dc.rennagroup.ru</a></li>
                                    <li><a href="tel:+74732070051">+7 (473) 207-00-51</a></li>
                                </ul>
                            </div>
                            <div class="item-content">
                                <span>Лидер-Новокубанск</span>
                                <ul>
                                    <li><a href="mailto:lider.nvkb@dc.rennagroup.ru">lider.nvkb@dc.rennagroup.ru</a></li>
                                    <li><a href="tel:+78619545258">+7 (86195) 4-52-58</a></li>
                                </ul>
                            </div>
                            <div class="item-content">
                                <span>Лидер-Шахты</span>
                                <ul>
                                    <li><a href="mailto:lider.shahti@dc.rennagroup.ru">lider.shahti@dc.rennagroup.ru</a></li>
                                    <li><a href="tel:+78636238211">+7 (8636) 23-82-11</a></li>
                                </ul>
                            </div>
                            <div class="item-content">
                                <span>Лидер-Сочи</span>
                                <ul>
                                    <li><a href="mailto:info-sochi@dc.rennagroup.ru">info-sochi@dc.rennagroup.ru</a></li>
                                    <li><a href="tel:+78622686560">+7 (8622) 68-65-60</a></li>
                                </ul>
                            </div>
                            <div class="item-content">
                                <span>Лидер-Новороссийск</span>
                                <ul>
                                    <li><a href="mailto:lider_nvrsk@dc.rennagroup.ru">lider_nvrsk@dc.rennagroup.ru</a></li>
                                    <li><a href="tel:+79180401179">+7 (918) 040-11-79</a></li>
                                </ul>
                            </div>
                            <div class="item-content">
                                <span>Лидер-Ростов</span>
                                <ul>
                                    <li><a href="mailto:lider-rostov@dc.rennagroup.ru">lider-rostov@dc.rennagroup.ru</a></li>
                                    <li><a href="tel:+78632273944">+7 (863) 227-39-44</a></li>
                                    <li><a href="tel:+78632275853">+7 (863) 227-58-53</a></li>
                                </ul>
                            </div>
                            <div class="item-content">
                                <span>Отдел продаж &laquo;Белогорье&raquo;</span>
                                <ul>
                                    <li><a href="mailto:zakaz@amkk.ru">zakaz@amkk.ru</a></li>
                                    <li>
                                        <a href="tel:+74723444162">+7 (47234) 4-41-62</a>, <a href="tel:+74723445321">+7 (47234) 4-41-62</a> 
                                    </li>
                                </ul>
                            </div>
                            <div class="item-content">
                                <span>Отдел продаж &laquo;Крым&raquo;</span>
                                <ul>
                                    <li><a href="mailto:m.bakatov@dc.rennagroup.ru">m.bakatov@dc.rennagroup.ru</a></li>
                                    <li>
                                        <a href="tel:+79897639948">+7 (989) 763-99-48</a>, <a href="tel:+79787748102">+7 (978) 774-81-02</a> 
                                    </li>
                                </ul>
                            </div>    


                        </div>
                    </div>

                    <div class="item">
                        <div class="item-title">Ренна-Ритейл</div>
                        <div class="item-content">
                            <span></span>
                            <ul>
                                <li><a href="mailto:info@retail.rennagroup.ru">info@retail.rennagroup.ru</a></li>
                                
                            </ul>
                        </div>
                    </div>


                    <div class="item">
                        <div class="item-title">Логистика</div>
                        <div class="item-content">
                            <span>Ренна-Логистик</span>
                            <ul>
                                <li><a href="mailto:info@logist.rennagroup.ru">info@logist.rennagroup.ru</a></li>
                                <li><a href="tel:+74732620286">+7 (473) 262-02-86</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-title">Маркетинг</div>
                        <div class="item-content">
                            <span>Департамент Маркетинга</span>
                            <ul>
                                <li><a href="mailto:info@rennagroup.ru">info@rennagroup.ru</a></li>
                                
                            </ul>
                        </div>
                    </div>
-->

                    <div class="item">
                        <div class="item-title">СМИ</div>
                        <div class="item-content">
                            <span>PR-служба</span>
                            <ul>
                                <li><a href="mailto:pr@rennagroup.ru">pr@rennagroup.ru</a></li>
                            </ul>
                        </div>
                    </div>

                    <div class="item-append">
                            Примечание. С контактными данными наших отдельных предприятий и подразделений Вы можете ознакомиться в разделе "Вакансии".
                        
                    </div>


                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Feedback from "../Feedback";

    export default {
        name: "Contacts",
        components: {
            "feedback": Feedback
        }
    }
</script>
